import styles from "./tablePrompt.module.css"
import pointerImage from "../../../images/pointer-image-svg.svg"
import { useDispatch, useSelector } from "react-redux"

function TablePrompt({setPromptToggle}) {
  const tuggleFun = () => {
    localStorage.setItem('tablePromptToggle', true)
    setPromptToggle(true)
  }
  return (
    <section className={styles.section}>
      <div className={styles.containerWrapper}>
        <div className={styles.container}>
          <img src={pointerImage} className={styles.imgPointer}/>
          <div className={styles.title}>
            Двигайте столбцы, <br /> чтобы увидеть все показатели
          </div>
          <div className={styles.subTitle}>
          Для этого кликайте на стрелки <br /> в правой верхней части таблицы
          </div>
          <button className={styles.button} onClick={() => {tuggleFun()}} >Хорошо</button>
        </div>
      </div>
    </section>
  )
}

export default TablePrompt
